<template>
  
    <div class="pricing-plan-cards-section">
        <div class="col-lg-12 pricing-card-section">
            <div class="pricing-card">
                <h2>Proficiat! De eerste stap is gezet! Wij contacteren u binnenkort met meer informatie.</h2>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>